import firebase from "firebase";

export const googleProvider = new firebase.auth.GoogleAuthProvider();